import A11yDialog from 'a11y-dialog';

export function dialog(id) {
  const element = document.getElementById(id);
  if (!element) return;
  new A11yDialog(element);
}
